<template>
  <div class="page-content">
    <div class="top-content">
      <img src="../../assets/image/login/kcidea-icon.png" alt="" />
      <div class="title">昆虫软件客户管理系统</div>
    </div>
    <div class="main-content">
      <div class="line-name">
        <img src="../../assets/image/login/account.png" alt="" />
        <span>账号</span>
      </div>
      <div class="ipt-box">
        <el-input class="no-border" v-model="userName" placeholder="请输入内容" clearable></el-input>
      </div>
      <div class="line-name psw-line">
        <img src="../../assets/image/login/password.png" alt="" />
        <span>密码</span>
      </div>
      <div class="ipt-box">
        <el-input
          class="no-border"
          v-model="password"
          placeholder="请输入内容"
          clearable
          type="password"
        ></el-input>
      </div>
      <div class="login-btn" @click="login">登录</div>
      <!-- <div class="other-login-box">
        <div class="line"></div>
        <div class="text">第三方登录</div>
        <div class="weixin">
          <img src="../../assets/image/login/weixin.png" alt="" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { login } from "@/api/user/index.js";
export default {
  data() {
    return {
      userName: "",
      password: "",
    };
  },
  methods: {
    login() {
      let userForm = {
        userName: this.userName,
        password: this.$utils.md5Password(this.password),
      };
      login(userForm)
        .then((res) => {
          //token存在本地localStorage
          window.localStorage.setItem("accessToken", res.data.token);
          this.$store.commit("setUserData", res.data);
          this.$router.replace("/home");
        })
        .catch(({ data }) => {
          this.$store.commit("setUserData", {});
          this.$MessageBox.MessageWarning(data.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-content {
  font-size: 1.14rem;
}
.top-content {
  width: 100%;
  height: 30vh;
  background: url("../../assets/image/login/top-bg.png") no-repeat,
    linear-gradient(90deg, #e8f2ff 0%, #f6faff 50%, #f2f8ff 100%);
  background-size: 100%;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    width: 10.6rem;
  }
  .title {
    font-weight: 550;
    margin-top: 0.56rem;
  }
}
.main-content {
  background-color: #fff;
  margin-top: -2.5rem;
  height: calc(70vh + 2.5rem);
  border-radius: 20px 20px 0 0;
  padding: 3.14rem 2rem;
  .line-name {
    display: flex;
    align-items: center;
    img {
      width: 1.13rem;
      height: 1.29rem;
      margin-right: 0.5rem;
    }
  }
  .ipt-box {
    border-bottom: 1px solid #ededed;
    margin-top: 1.36rem;
  }
  .psw-line {
    margin-top: 6vh;
  }
  .login-btn {
    background-color: #175ebe;
    border-radius: 24px;
    color: #fff;
    padding: 10px 0;
    text-align: center;
    margin-top: 8vh;
  }
  .other-login-box {
    margin-top: 15vh;
    color: #999;
    position: relative;
    padding: 0;
    font-size: 1rem;
    overflow: hidden;

    .line {
      position: absolute;
      width: 100%;
      top: 0.6rem;
      border-top: 1px solid #ededed;
    }
    .text {
      position: absolute;
      display: inline-block;
      width: 7rem;
      text-align: center;
      background-color: #fff;
      left: 50%;
      transform: translateX(-50%);
    }
    .weixin {
      text-align: center;
      margin-top: 2.5rem;
      img {
        width: 2.86rem;
        height: 2.86rem;
      }
    }
  }
}
::v-deep .el-input__inner {
  padding-left: 0;
  font-size: 1.29rem;
  color: #000;
}
</style>
